import { motion } from 'framer-motion'
import { useRouter } from 'next/router'
import React from 'react'

import ImageByWidthDevice from '@/components/ImageByWidthDevice'
import { introRightVariants } from '@/config/const'
import { getWhySezRegulationPolicy } from '@/services/why-sez'
import { useAppSelector } from '@/utils/hooks'

import icon from '~/assets/images/investment/why-invest/regulation-icon.png'
import iconShadow from '~/assets/images/investment/why-invest/regulation-icon-shadow.png'

const Regulations: React.FC = () => {
  const router = useRouter()
  const { data: regulationPolicy } = useAppSelector(
    getWhySezRegulationPolicy.select({
      headers: { 'Accept-Language': String(router.locale) },
    })
  )
  if (regulationPolicy) {
    return (
      <div className='2xl:bg-red relative flex min-h-[640px] max-w-[1440px] flex-col overflow-hidden bg-white lg:flex-row'>
        <div className='relative h-[371px] md:h-[600px] lg:static lg:h-auto'>
          <div className='clip-para-reverse absolute -left-[92.32px] top-0 z-10 h-full w-[421px] bg-yellow sml:w-[451px] md:w-[581.401px]' />
          <div className='clip-para-reverse absolute -left-[162.32px] top-0 z-20 h-full w-[421px] bg-orange sml:w-[451px] md:w-[581.401px]' />

          <div className='absolute bottom-0 left-0 z-30'>
            <div className='absolute inset-0 z-10' />
            {regulationPolicy?.data.imageFiles && (
              <ImageByWidthDevice
                images={regulationPolicy?.data.imageFiles}
                alt='background image'
                className='w-[600px]'
              />
            )}
          </div>
        </div>

        <div className='container relative flex h-full items-center justify-start py-8 lg:justify-end lg:py-[100px]'>
          <motion.div
            className='relative flex w-full flex-col gap-6 lg:w-[539px] lg:gap-[34px]'
            initial='hide'
            whileInView='show'
            exit='hide'
            variants={introRightVariants}
            viewport={{ once: true }}
          >
            <div className='relative'>
              <div className='absolute inset-0 z-10' />

              <img
                src={icon.src}
                alt='Regulation Icon'
                className='w-8 lg:w-[54px]'
              />
            </div>

            <div className='absolute -left-[4px] -top-[17px] lg:-left-[17px] lg:-top-[48.5px]'>
              <div className='absolute inset-0 z-10' />

              <img
                src={iconShadow.src}
                alt='Regulation Icon Shadow'
                className='h-[56px] w-[56px] lg:h-[114px] lg:w-[110.226px]'
              />
            </div>

            <h5 className='text-2xl font-extrabold uppercase leading-[normal] text-red lg:text-[38px]'>
              {regulationPolicy?.data.title ?? ''}
            </h5>
            <div
              className='text-sm leading-normal tracking-[-0.176px] text-gray-1 lg:text-base'
              dangerouslySetInnerHTML={{ __html: regulationPolicy?.data.description ?? '' }}
            />
          </motion.div>
        </div>
      </div>
    )
  }
  return null
}

export default Regulations
